import { IApi } from './api.service';
import { ApiEndpoints } from './endpoints';

export const reorderItems = async (endpoint: ApiEndpoints, api: IApi, movedItemId: number, newIndex: number): Promise<void> => {
    await api.put(endpoint.replace(':id', String(movedItemId)), { index: newIndex });
};
